import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { apiConstants } from '../_constants';
import { userAbb, userService } from '../_services';
import { useUser } from '../Hook/useUser';
import { isEnglish } from '../_helpers';
import './components.css';

export function Header() {
  const dropdownRef = useRef(null);
  const location = useLocation();
  const localuser = useUser();
  const [showMoreOptions, setShowMoreOptions] = useState(false);

  // Define the target views where dynamic direction is desired
  const isTargetView =
    location.pathname.includes('/topiclist') ||
    location.pathname.includes('/notesingle') ||
    location.pathname.includes('/course');

  // Only check for English direction on target views
  const isEnglishHeader = isTargetView && isEnglish(location.state?.title);

  useEffect(() => {
    //To handle the dropdown close when user click outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowMoreOptions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      className={'header_component ' + (isEnglishHeader ? 'ltrtext' : 'rtltext')}
      dir={isEnglishHeader ? 'ltr' : 'rtl'}
    >
      <div className='container navbar '>
        <Link to='/' className='navbar-brand'>
          <img className='login_main_logo' src='/img/edraak_logo.png' />
        </Link>
        <div className='navbar_support  d-flex align-items-center' id='navbarSupportedContent'>
          {showMoreOptions && (
            <div ref={dropdownRef}>
              <ul className='navbar-nav flex-right'>
                <li className={'nav-item dropdown  menu-ddown show '}>
                  <div
                    onClick={() => setShowMoreOptions(false)}
                    className={
                      'dropdown-menu dropdown-menu-right menu-ddown-content show moreoptions'
                    }
                  >
                    <i
                      className='fa fa-times-circle-o  class'
                      onClick={() => setShowMoreOptions(false)}
                      aria-hidden='true'
                    ></i>
                    <Link className='dropdown-item' to='/courselist'>
                      <p className='popover_links mb-0'> My Courses</p>
                    </Link>
                    <Link className='dropdown-item' to='/bookmarklist'>
                      <p className='popover_links mb-0'> Bookmarks</p>
                    </Link>

                    <Link className='dropdown-item' to='/Payment_history'>
                      <p className='popover_links mb-0'> Payments</p>
                    </Link>
                    <div className='divider'></div>
                    <a className='dropdown-item text-danger' onClick={() => userService.logout()}>
                      <p className='popover_links mb-0'>Log out</p>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          )}
          <div
            className='showoption'
            onClick={() => {
              setShowMoreOptions(!showMoreOptions);
            }}
          >
            <img className='main_menu_option' src='/img/menu.png' />
          </div>

          <Link to='/profile' className='text-decoration-none'>
            {localuser?.profile_image ? (
              <img
                className='main_menu_profile'
                src={
                  localuser?.profile_image
                    ? apiConstants.imgUrl + localuser?.profile_image
                    : '/img/user_dummy.png'
                }
              />
            ) : (
              <div className='main_menu_abb'>
                {userAbb(localuser?.first_name + ' ' + localuser?.last_name)}
              </div>
            )}
          </Link>
        </div>
      </div>
    </div>
  );
}
